export default {
  name: 'tableForm',
  template: `
<section>
  <div v-if="crmObjectData.length !== 0">
    <el-row :gutter="20" class="fw-medium text-secondary border-bottom pb-2 mb-2">
      <el-col :span="1">
        #
      </el-col>
      <el-col :span="16">
        Выберите позицию для заказа
      </el-col>
      <el-col :span="4">
        Количество
      </el-col>
      <el-col :span="3">
        Цена
      </el-col>
    </el-row>
    <el-row :gutter="20" v-for="(row,index) in crmObjectData" v-if="crmObjectData[index].isTopPurchase || isShowAllList" class="d-flex align-items-center fs-12 py-2 border-bottom">
      <el-col :span="1">
        <el-checkbox v-model="crmObjectData[index].isChecked"></el-checkbox>
      </el-col>
      <el-col :span="16">
        <span v-html="row.fullName" class="text-wrap text-break"></span>
        <el-popover
          v-if="row.description"
          placement="top-start"
          width="600"
          visible-arrow="false"
          trigger="hover">
          <div class="p-3 text-wrap text-break fs-13" v-html="row.description"></div>
          <span slot="reference"> <i class="el-icon-info text-primary"></i></span>
        </el-popover>
      </el-col>
      <el-col :span="4">
        <el-input-number size="mini" style="width:90px" min="0" max="99" :value="crmObjectData[index].quantity" @input="editCartQuantity(index, $event)"></el-input-number>
      </el-col>
      <el-col :span="3">
        <span class="text-nowrap"><span v-html="row.price" class="fw-bold"></span> руб.</span>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="border-bottom text-center" @mouseover.native="isMouseOverMore = true" @mouseout.native="isMouseOverMore = false">
        <el-col v-if="!isShowAllList" :class="isMouseOverMore ? 'text-primary bg-light':''" @click.native="isShowAllList = true" style="cursor: pointer" >
            <i class="el-icon-caret-bottom"></i> <transition name="el-zoom-in-center"><span v-show="isMouseOverMore">Раскрыть список</span></transition>
        </el-col>
        <el-col v-else @click.native="isShowAllList = false" style="cursor: pointer" :class="isMouseOverMore ? 'text-primary bg-light':''">
            <i class="el-icon-caret-top"></i>
            <span class="text-secondary">Если в перечне нет нужной позиции, перейдите к</span> <a size="mini" @click.stop href="https://cryptopro.ru/order/OrderForm.aspx?button=csp_all_positions&online=true" target="_blank" rel="noopener noreferrer">полному списку <i class="el-icon-right"></i></a>
            <i class="el-icon-caret-top"></i>
        </el-col>
    </el-row>
  </div>
  <el-skeleton
    v-if="crmObjectData.length === 0"
    v-loading="crmObjectData.length === 0" 
    :rows="5" 
    animated 
    />
  <el-row type="flex" justify="space-around" class="mt-4">
    <el-col :span="18">
        <div class="text-break text-wrap" style="color: #8896ab;">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" /><path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M7 12a5 5 0 0 1 5 -5" /><path d="M12 17a5 5 0 0 0 5 -5" /></svg>
          При необходимости приобретения дистрибутива на DVD или сертификатов технической поддержки воспользуйтесь основной формой заказа <a style="color: #8896ab;" href="https://cryptopro.ru/order/OrderForm.aspx?button=csp_all_positions&online=true">по ссылке</a>.
        </div>
    </el-col>
    <el-col :span="6">
      <el-skeleton
        v-if="crmObjectData.length === 0"
        :rows="1"
        animated
      />
      <div v-else style="text-align: end;" class="fs-9 font-osc fw-bold">
        <div><span class="fs-10 text-primary">ИТОГО К ОПЛАТЕ</span></div>
        <div><span class="text-nowrap text-dark">{{priceTotal}} руб.</span></div>
      </div>
    </el-col>
  </el-row>
  <el-row type="flex" justify="end" class="bottom clearfix pt-2 mt-5">
    <el-button :size="isMobile?'mini':''" icon="el-icon-close" @click="$emit('dialog',false)">Отмена</el-button>
    <el-button :size="isMobile?'mini':''" type="primary" @click="nextStep()" :disabled="!selectedRows.length">Продолжить оформление</el-button>
  </el-row>
</section>
`,
  props: {
    isMobile: Boolean
  },
  data () {
    return {
      crmObjectData: [],
      numberReconnectionTry: 0,
      numberReconnectionAttempts: 5,
      isShowAllList: false,
      isMouseOverMore: false
    }
  },
  computed: {
    selectedRows: function () {
      return this.crmObjectData.filter(item => item.isChecked)
    },
    priceTotal: function () {
      let priceTotal = 0
      this.selectedRows.forEach(selected => {
        priceTotal += selected.quantity * selected.price
      })
      return priceTotal
    },
    cartData: function () {
      const cart = []
      const details = {}
      this.selectedRows.forEach(selected => {
        cart.push(
          {
            productId: selected.productId,
            quantity: selected.quantity
          }
        )
        details[selected.productId] =
          {
            fullName: selected.fullName,
            description: selected.description
          }
      })
      return {
        cart,
        priceTotal: this.priceTotal,
        details
      }
    }
  },
  methods: {
    requestData: async function ({ sectionType, productType, clientType } = { sectionType: 'group', productType: 'index', clientType: 'individual' }) {
      const oReq = new XMLHttpRequest()
      oReq.open('GET', window.cpSite.module.purchaseForm.state.apiUrl + `/${sectionType}/${productType}/${clientType}`, true)

      this.numberReconnectionTry++
      try {
        await new Promise((resolve, reject) => {
          oReq.onload = function () {
            if (oReq.status >= 200 && oReq.status < 300) {
              resolve()
            } else {
              reject(new Error(`HTTP Error: ${oReq.status}`))
            }
          }
          oReq.onerror = function () {
            reject(new Error('Network error'))
          }
          oReq.send()
        })
        this.crmObjectData = JSON.parse(oReq.responseText)
        this.modifyCrmObjectData()
      } catch (err) {
        // Обработка ошибок
        console.error('Request error:', err.message)
        // Продолжать восстановить соединение несколько раз
        if (this.numberReconnectionTry < this.numberReconnectionAttempts) {
          const app = this
          setTimeout(function () { app.requestData() }, 2000)
        } else {
          /**
           * Не удалось получить данные из CRM о позициях в продаже
           */
          this.$message({
            showClose: true,
            message: 'Ошибка соединения. Попробуйте позже.',
            type: 'error',
            duration: 10000
          })
          this.$emit('dialog', false)
        }
      }
      return this.crmObjectData
    },
    modifyCrmObjectData () {
      /*      this.crmObjectData.push({
        description: 'Лицензия1',
        fullName: 'Лицензия1 на право',
        price: 4951,
        productId: '800b669c-25ea-e711-b2ef-0025900a9ce7-1',
        productTypeCode: 'License',
        tags: ["product.top_purchase"]
      }) */
      // Дополняем объект параметрами
      this.crmObjectData.forEach((el, index) => {
        this.$set(this.crmObjectData[index], 'idx', index) // Доп. Параметр, чтобы легче ориентироваться по списку
        this.$set(this.crmObjectData[index], 'quantity', 0)
        this.$set(this.crmObjectData[index], 'isChecked', false)
        this.$set(this.crmObjectData[index], 'isTopPurchase', this.crmObjectData[index]?.tags.includes('product.top_purchase'))
      })
      // Кладём в корзину первого в списке
      this.crmObjectData[0].quantity = 1
      this.crmObjectData[0].isChecked = true
      // this.$nextTick(() => { this.$refs.multipleTable.toggleAllSelection() })
    },
    editCartQuantity (index, value) {
      this.$set(this.crmObjectData[index], 'quantity', +value)
      if (+value < 1) {
        this.$set(this.crmObjectData[index], 'isChecked', false)
      }
      if (+value >= 1) {
        this.$set(this.crmObjectData[index], 'isChecked', true)
      }
    },
    nextStep () {
      this.$emit('cartData', this.cartData)
    }
  },
  watch: {
    selectedRows (value) {
      this.crmObjectData.forEach((el, index) => {
        if (el.isChecked && +el.quantity < 1) {
          el.quantity = 1
        }
        if (!el.isChecked && +el.quantity > 0) {
          el.quantity = 0
        }
      })
    }
  },
  created: function () {
  },
  mounted: function () {
    /**
     * Из-за особенностей всплытия диалогового окна компонент не успевает нарисоваться, когда базовый компонент уже начинает инициализацию.
     * Поэтому нужно сначала дождаться готовности внутреннего компонента и послать сигнал готовности.
     */
    this.$emit('trigger-isReady')
  }
}
